import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetData } from '../selectors/dataSelector'
import { makeGetDomain } from '../selectors/chartDomainSelector'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import BrushZoomChart from './BrushZoomChart'


class WaterMonitoringBarChart extends PureComponent {
  render () {
    const { data, datetime, domain, render, title, chartStyles } = this.props

    if (!arrayIsNotEmpty(data) || !render) {
      return null
    }

    return (
      <BrushZoomChart
        data={data}
        title={title}
        chartStyles={chartStyles}
        datetime={datetime}
        domain={domain}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()
  const getDomain = makeGetDomain()
  const getLayerRendered = makeGetLayerRendered()

  const mapStateToProps = (state, ownProps) => {
    const { id, datetimeId, getData=getFeaturesFromGeoJson } = ownProps
    console.log(ownProps)
    const data = getData(state, 'WaterLakeTss', getFeaturesFromGeoJson)
    const datetime = getDatetime(state, datetimeId)
    console.log(data)

    return {
      data,
      datetime,
      domain: getDomain(state, data, datetime),
      fetching: state.data.fetching,
      render: getLayerRendered(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {}
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  WaterMonitoringBarChart
)



// WEBPACK FOOTER //
// ./src/charts/WaterMonitoringBarChart.js